<div class="maincontainer">
    <div class="orderhistorycontainer">
        <div class="fs" *ngIf="orderHistory$ | async as order">
            <div class="title">{{ order.id }}</div>
            <div class="basket-info">
                <div class="detail">
                    <div class="label">{{ 'order.history.headline.ordered' | translate }}</div>
                    <div class="value">{{ order.placed | date:'dd.MM.yyyy HH:mm'}}</div>
                </div>
                <div class="detail">
                    <div class="label">{{ 'order.history.headline.orderedBy' | translate }}</div>
                    <div class="value">{{ order.buyer?.firstName }} {{ order.buyer?.lastName }}</div>
                </div>
                <div class="detail">
                    <div class="label">{{ 'order.history.header.status' | translate }}</div>
                    <div class="value">{{ order.statusDisplay }}</div>
                </div>
            </div>
            <kion-device-short-info
                    [device]="device$ | async"
                    [enableDeviceLink]="true"
            >
            </kion-device-short-info>
            <kion-feature-quote-list
                    [device]="device$ | async"
                    [features]="features$ | async"
                    [deviceCart]="deviceCart$ | async"
                    [roles]="roles$ | async"
                    [disableDelete]="true"
                    [disableHealthyCheck]="true"
            >
            </kion-feature-quote-list>
            <div class="order-info" *ngIf="deviceCart$ | async as cart">
                <div class="spacer hideOnPhone"></div>
                <div class="sum">
                    <div class="pricing no-border">
                        <div class="label">
                            <div class="amount">
                                {{ 'basket.summary.totalAmount.headline' | translate }}
                            </div>
                            <div class="vat">
                                {{ 'basket.summary.totalAmount.vat.excluded' | translate }}
                            </div>
                        </div>
                        <div class="value">{{ order.total?.formattedValue }}</div>
                    </div>
                </div>
            </div>
            <kion-cms-order-history-quote
            [orderHistory]="orderHistory$ | async"
            [deviceCart]="deviceCart$ | async"
            [canEdit]="canEdit$ | async"
            (formChange)="poformChange($event)"
            ></kion-cms-order-history-quote>
        </div>
    </div>
</div>
